"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var dom_1 = require("../../runtime/dom");
var awsui_table_page_size_selector_1 = require("./awsui-table-page-size-selector");
var awsui_table_content_selector_1 = require("./awsui-table-content-selector");
var awsui_table_wrap_lines_1 = require("./awsui-table-wrap-lines");
var BaseCollectionPreferencesWrapper = /** @class */ (function (_super) {
    __extends(BaseCollectionPreferencesWrapper, _super);
    function BaseCollectionPreferencesWrapper() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    BaseCollectionPreferencesWrapper.prototype.findTriggerButton = function () {
        return this.find(".awsui-" + this.name + "-preferences-trigger button");
    };
    BaseCollectionPreferencesWrapper.prototype.findCancelButton = function () {
        return this.find(".awsui-" + this.name + "-preferences-cancel-button button");
    };
    BaseCollectionPreferencesWrapper.prototype.findConfirmButton = function () {
        return this.find(".awsui-" + this.name + "-preferences-confirm-button button");
    };
    return BaseCollectionPreferencesWrapper;
}(dom_1.ComponentWrapper));
exports.BaseCollectionPreferencesWrapper = BaseCollectionPreferencesWrapper;
var TablePreferencesWrapper = /** @class */ (function (_super) {
    __extends(TablePreferencesWrapper, _super);
    function TablePreferencesWrapper(element) {
        var _this = _super.call(this, element) || this;
        _this.name = 'table';
        return _this;
    }
    TablePreferencesWrapper.prototype.findWrapLines = function () {
        return new awsui_table_wrap_lines_1.default(this.find('awsui-table-wrap-lines').getElement());
    };
    TablePreferencesWrapper.prototype.findPageSizeSelector = function () {
        return new awsui_table_page_size_selector_1.default(this.find('awsui-table-page-size-selector').getElement());
    };
    TablePreferencesWrapper.prototype.findContentSelector = function () {
        return new awsui_table_content_selector_1.default(this.find('awsui-table-content-selector').getElement());
    };
    return TablePreferencesWrapper;
}(BaseCollectionPreferencesWrapper));
exports.default = TablePreferencesWrapper;
//# sourceMappingURL=awsui-table-preferences.js.map